var map = {
	"./felinos.png": 132,
	"./mi-liga-2.png": 295,
	"./mi-liga.png": 336,
	"./piratas.png": 133,
	"./tiburones.png": 134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos ^\.\/.*$
// module id = 335
// module chunks = 0